import { Injectable } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { Subscription, timer } from 'rxjs';
import { addMinutes, addSeconds } from 'date-fns';

import { InactivityTimeoutComponent } from './inactivity-timeout.component';
import { SecurityService } from '../security/security.service';

@Injectable({
	providedIn: 'root'
})
export class InactivityTimeoutService {

	subsriptions = new Subscription();
	modalOpen = false;

	constructor(private modal: NgbModal, private sec: SecurityService) {
		this.startTimer();
	}

	startTimer() {
		const source = timer(0, 1000);
		this.subsriptions.add(source.subscribe(() => {
			const user = this.sec.getUser();
			if (user?.inactivityTimeout) {
				if (localStorage.getItem('lastAccess')) {
					const lastAccessedDate = new Date(JSON.parse(localStorage.getItem('lastAccess')));
					const endDate = addSeconds(addMinutes(lastAccessedDate, 4), 30);
					if ((new Date()) >= endDate) {
						if (!this.modalOpen) {
							this.modalOpen = true;
							this.modal.dismissAll();
							this.modal.open(InactivityTimeoutComponent, { 'beforeDismiss': () => { this.modalOpen = false; return true; } });
						}
					}
				}
				else {
					this.sec.setSecurity(null, null, null);
				}
			}
		}));
	}

	stopTimer() {
		this.subsriptions.unsubscribe();
	}
}
